import { css } from 'lit';
// import { SHOPS } from '../../constants';
// import { SHOPS } from '../../constants';

export const sectionStyles = css`

  .grid-container {
    display: grid;
    width: 100%;
    box-sizing: border-box; 
    align-content: start;
    grid-template-rows: auto; 
    grid-template-columns: repeat(2, 1fr);       
  }
  .grid-container.phone {
    gap: var(--sl-spacing-2x-small);
    padding: var(--sl-spacing-2x-small);
  }
  .grid-container.tablet {
    gap: var(--sl-spacing-x-small);
    padding: var(--sl-spacing-x-small);
    grid-template-columns: repeat(3, 1fr);       
  }
  .grid-container.laptop {
    gap: var(--sl-spacing-small);
    padding: var(--sl-spacing-small);
    grid-template-columns: repeat(5, 1fr);       
  }
  .grid-container.desktop {
    gap: var(--sl-spacing-medium);
    padding: var(--sl-spacing-medium);
    grid-template-columns: repeat(6, 1fr);       
  }

`;